import React, { createContext, useContext, useState } from "react";
import ReactDOM from "react-dom";
import { PopUpGlobalContext } from "../../context/popup";
import { IPortfolioComposition } from "../../interfaces/IPortfolio";
import {
  Btn,
  Close,
  Content,
  Details,
  Header,
  Image,
  Img,
  Inner,
  Item,
  Overlay,
  Section,
  Thumbnail,
  ThumbnailPopUp,
  Title,
  TitlePopUp,
} from "./styles/Portfolio";

interface IPopUpContext {
  showPopUp: boolean;
  setShowPopUp: React.Dispatch<React.SetStateAction<boolean>>;
}

export const PopUpContext = createContext<IPopUpContext>({
  showPopUp: false,
  setShowPopUp: () => {},
});

const Portfolio: React.FC & IPortfolioComposition = ({
  children,
  ...restProps
}) => <Section {...restProps}>{children}</Section>;

Portfolio.Item = function PortfolioItem({ children, ...restProps }) {
  const [showPopUp, setShowPopUp] = useState(false);

  return (
    <PopUpContext.Provider value={{ showPopUp, setShowPopUp }}>
      <Item {...restProps}>{children}</Item>
    </PopUpContext.Provider>
  );
};

Portfolio.Thumbnail = function PortfolioThumbnail({ children, ...restProps }) {
  return <Thumbnail {...restProps}>{children}</Thumbnail>;
};

Portfolio.Image = function PortfolioImage({ ...restProps }) {
  return <Image {...restProps} />;
};

Portfolio.Title = function PortfolioTitle({ children, ...restProps }) {
  return <Title {...restProps}>{children}</Title>;
};

Portfolio.Details = function PortfolioDetails({ children, ...restProps }) {
  return <Details {...restProps}>{children}</Details>;
};

Portfolio.Button = function PortfolioButton({ children, ...restProps }) {
  const { setShowPopUp } = useContext(PopUpContext);
  const { setPopUpOpen } = useContext(PopUpGlobalContext);

  const handleClick = () => {
    setShowPopUp((showPrev) => !showPrev);
    setPopUpOpen((showPrev) => !showPrev);
  };

  return (
    <Btn onClick={handleClick} {...restProps}>
      {children}
    </Btn>
  );
};

Portfolio.Content = function PortfolioContent({
  src,
  title,
  children,
  ...restProps
}) {
  const { showPopUp, setShowPopUp } = useContext(PopUpContext);
  const { setPopUpOpen } = useContext(PopUpGlobalContext);
  const handleClick = () => {
    setShowPopUp((showPrev) => !showPrev);
    setPopUpOpen((showPrev) => !showPrev);
  };
  return showPopUp
    ? ReactDOM.createPortal(
        <Overlay onClick={handleClick}>
          <Inner>
            <Content open={showPopUp} {...restProps}>
              <Header>
                <Close>
                  <i className='fas fa-times' />
                </Close>
                <ThumbnailPopUp>
                  <Img src={src} alt='Header Image Work' />
                </ThumbnailPopUp>
                <TitlePopUp>{title}</TitlePopUp>
              </Header>
              {children}
            </Content>
          </Inner>
        </Overlay>,
        document.body
      )
    : null;
};

export default Portfolio;
